export type TipCarsPriceNoteAttribute = {
  code: TipCarsPriceNoteAttribute.code;
  readonly type?: TipCarsPriceNoteAttribute.type;
  readonly title?: string;
  value: string | null;
  readonly defaultValue?: string | null;
  readonly displayValue?: string | null;
  readonly extra?: any;
  readonly required?: boolean;
  override: boolean;
  readonly hasPublishControl?: boolean;
  publish: boolean;
};

export namespace TipCarsPriceNoteAttribute {
  export enum code {
    PRICE_NOTE = 'price_note',
  }

  export enum type {
    TEXT = 'text',
  }
}
